// src/api/micrositePublic.ts
//
// Public (unauthenticated) API functions for microsite pages.
// Uses raw fetch() — no Axios, no auth interceptors.
// This module is imported by the lightweight public app and must not
// pull in any heavy dependencies.

import type { PublicMicrositeData } from '@/types/microsite';

const API_URL = import.meta.env.VITE_API_URL;

export async function getPublicMicrosite(slug: string): Promise<PublicMicrositeData> {
  const response = await fetch(`${API_URL}/public/microsite/${slug}`);
  if (!response.ok) {
    const error = await response.json();
    throw error;
  }
  return response.json();
}

export async function logMicrositeEvent(
  slug: string,
  event: {
    event_type: string;
    link_id?: string;
    link_label?: string;
    referrer?: string;
    tracking_id?: string;
  },
): Promise<void> {
  await fetch(`${API_URL}/public/microsite/${slug}/events`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(event),
  });
}

export async function submitMicrositeEmailSignup(slug: string, email: string): Promise<void> {
  const response = await fetch(`${API_URL}/public/microsite/${slug}/signup`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email }),
  });
  if (!response.ok) {
    const error = await response.json();
    throw error;
  }
}

export async function reportMicrosite(
  slug: string,
  reason: string,
  details?: string,
): Promise<void> {
  await fetch(`${API_URL}/public/microsite/${slug}/report`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ reason, details }),
  });
}
